const mutationTypes = {
  CALL_SUCCESS: 'call_success',
  ROOM_SUCCESS: 'room_success',
  UPDATE_ROOM_STATUS: 'update_room_status',
  SET_TOKEN: 'set_token',
  LOADING: 'loading',
  FAILURE: 'failure',
};

export { mutationTypes };